import { useEffect, useState } from 'react';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useQueryIntroducers } from 'lendingApi/lendingApiHooks';
import styles from './UserManagement.module.css';
import { UsersTable } from './UsersTable/UsersTable';

export const UserManagement = () => {
  const { introducer, introducerCompany } = useIntroducerData();
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const debounceTimeout = setTimeout(
      () => setDebouncedSearch(searchQuery.trim()),
      300,
    );
    return () => clearTimeout(debounceTimeout);
  }, [searchQuery]);

  const { data, isPending } = useQueryIntroducers({
    introducerAccountId: introducerCompany?.id ?? null,
    search: debouncedSearch || undefined,
  });

  return (
    <div className={styles.pageContent}>
      <h1 className={styles.heading}>User management</h1>
      <UsersTable
        users={data?.data.introducers ?? []}
        searchQuery={searchQuery}
        onSearchQueryChange={setSearchQuery}
        isLoading={isPending}
        currentIntroducerId={introducer?.id ?? null}
      />
    </div>
  );
};
